<app-content-header text="Payment Methods"></app-content-header>
  <div *ngIf="!isCcpEnabledInPreferredLocation && !isChangeMode" class="error-box alt p-15 text-center">
    <img
      height="24"
      width="24"
      src="../../../../assets/svg/ico_error_circle.svg"
    />
    <p class="error-box-text">
      You cannot make any change since your preferred location has not enabled the "Credit Card Processing" service.
    </p>
  </div>
<div class="payment-list-container" *ngIf="primaryPaymentCreditCard !== null">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="payment-list-title">Primary Payment Method</div>
    <span
      *ngIf="isCcpEnabledInPreferredLocation && !isChangeMode"
      class="change-link"
      (click)="enterChangeMode()"
      (keyup.enter)="enterChangeMode()"
      tabindex="0"
    >Change</span>
  </div>
  <app-payment-tile
    *ngIf="!isChangeMode || isChangeMode && !primaryPaymentCreditCard?.expired"
    [creditCard]="primaryPaymentCreditCard"
    [selectedCreditCard]="currentSelectedPrimaryPaymentCreditCard"
    [showRadio]="isChangeMode"
    [readOnly]="!isCcpEnabledInPreferredLocation"
    (toEdit)="onEditCreditCard($event)"
    (toDelete)="onDeleteCreditCard($event)"
    (selectedChange)="onChangeSelectedPrimary($event)"
  ></app-payment-tile>
</div>
<div class="payment-list-container" *ngIf="otherPaymentCreditCardList.length !== 0">
  <div class="payment-list-title mb-2">Other Payment Methods</div>
  <ng-container *ngFor="let creditCard of otherPaymentCreditCardList; index as i">
    <app-payment-tile
      *ngIf="!isChangeMode || isChangeMode && !creditCard?.expired"
      [creditCard]="creditCard"
      [selectedCreditCard]="currentSelectedPrimaryPaymentCreditCard"
      [showRadio]="isChangeMode"
      [readOnly]="!isCcpEnabledInPreferredLocation"
      (toEdit)="onEditCreditCard($event)"
      (toDelete)="onDeleteCreditCard($event)"
      (selectedChange)="onChangeSelectedPrimary($event)"
    ></app-payment-tile>
  </ng-container>
</div>
<app-arrow-link
  *ngIf="isCcpEnabledInPreferredLocation && !isChangeMode"
  text="+ Add a Credit Card"
  (handleClick)="onAddCreditCard()"
></app-arrow-link>

<!-- Change Primary -->
<div
  *ngIf="isChangeMode"
>
  <hr>
  <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
    <div class="col pr-sm-1">
      <button
        class="btn btn-outline-danger btn-block"
        (click)="isChangeMode = false"
      >Cancel</button>
    </div>
    <div class="col pl-sm-1">
      <button
        class="btn btn-danger btn-block mb-2 mb-sm-0"
        (click)="updatePrimaryCreditCard()"
      >Save</button>
    </div>
  </footer>
</div>
